import { Component } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { fadeInOutAnimation } from './shared/animations/fade-in-out.animation';
import { routeFadeAnimation } from './shared/animations/route-fade.animation';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';
import { PageLevelMessageComponent } from './shared/messages/page-level-message/page-level-message.component';

/**
 * Root application component.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	standalone: true,
	selector: 'claim-tracker-root',
	imports: [RouterOutlet, HeaderComponent, FooterComponent, BreadcrumbsComponent, PageLevelMessageComponent],
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	animations: [routeFadeAnimation, fadeInOutAnimation()]
})
export class AppComponent {
	/**
	 * @param contexts the Angular children outlet contexts
	 */
	constructor(private contexts: ChildrenOutletContexts) {}

	/**
	 * Get the route animation data for animations.
	 */
	getRouteAnimationData() {
		return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
	}
}
